import $oss from './oss'

export default {
  install(Vue) {
    Vue.prototype.$oss = $oss;
  }
}
